/* Llorrea verhalen: pijlen en bolletjes voor de reviewkaarten. Zoekt elementen steeds opnieuw op. */
(function () {
  if (window.lloStoriesReady) return;
  window.lloStoriesReady = true;

  function pages(rail) {
    if (!rail || !rail.clientWidth) return 1;
    return Math.max(1, Math.ceil((rail.scrollWidth - 2) / rail.clientWidth));
  }

  function current(rail) {
    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 2) return 0;
    if (rail.scrollLeft >= max - 2) return pages(rail) - 1;
    return Math.round(rail.scrollLeft / rail.clientWidth);
  }

  function sync(root) {
    var rail = root.querySelector('[data-llst-rail]');
    if (!rail) return;
    var dots = root.querySelector('[data-llst-dots]');
    var n = pages(rail);
    if (dots && dots.children.length !== n) {
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'llst__dot';
        b.setAttribute('data-llst-dot', i);
        b.setAttribute('aria-label', String(i + 1));
        dots.appendChild(b);
      }
    }
    var idx = current(rail);
    if (dots) {
      for (var j = 0; j < dots.children.length; j++) dots.children[j].classList.toggle('is-active', j === idx);
    }
    var max = rail.scrollWidth - rail.clientWidth;
    var prev = root.querySelector('[data-llst-prev]');
    var next = root.querySelector('[data-llst-next]');
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  }

  function syncAll() {
    var roots = document.querySelectorAll('[data-llst]');
    for (var i = 0; i < roots.length; i++) sync(roots[i]);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-llst-prev],[data-llst-next],[data-llst-dot]') : null;
    if (!t) return;
    var root = t.closest('[data-llst]');
    var rail = root && root.querySelector('[data-llst-rail]');
    if (!rail) return;
    var left;
    if (t.hasAttribute('data-llst-dot')) left = parseInt(t.getAttribute('data-llst-dot'), 10) * rail.clientWidth;
    else left = rail.scrollLeft + (t.hasAttribute('data-llst-next') ? 1 : -1) * rail.clientWidth;
    rail.scrollTo({ left: left, behavior: 'smooth' });
  });

  var raf;
  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (!rail || !rail.hasAttribute || !rail.hasAttribute('data-llst-rail')) return;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { sync(rail.closest('[data-llst]')); });
  }, true);

  window.addEventListener('resize', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
